//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const TreatmentOfChoice = createAsyncThunk(
  "TreatmentOfChoice",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingTreatmentOfChoice(""));
      const response = await UsePortalApi(
        `Patient/TreatmentOfChoice`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
        response[0].hasOwnProperty('entry') ? dispatch(gettingTreatmentOfChoiceSuccess(response[0].entry)) : dispatch(gettingTreatmentOfChoiceFailed())

      } else {
        dispatch(
          gettingTreatmentOfChoiceFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingTreatmentOfChoiceFailed(error));
    }
  }
);
const TreatmentOfChoiceSlice = createSlice({
  name: "TreatmentOfChoice",
  initialState: {
    TreatmentOfChoices: null,
    isGettingTreatmentOfChoices: false,
    error: false,
  },
  reducers: {
    gettingTreatmentOfChoice: (state, action) => {
      state.TreatmentOfChoices = null;
      state.isGettingTreatmentOfChoices = true;
      state.error = false;
    },
    gettingTreatmentOfChoiceSuccess: (state, action) => {
      state.TreatmentOfChoices = action.payload;
      state.isGettingTreatmentOfChoices = false;
      state.error = false;
    },
    gettingTreatmentOfChoiceFailed: (state, action) => {
      state.TreatmentOfChoices = null;
      state.isGettingTreatmentOfChoices = false;
      state.error = true;
    },
    gettingTreatmentOfChoiceClear: (state, action) => {
      state.TreatmentOfChoices = null;
      state.isGettingTreatmentOfChoices = false;
      state.error = false;
    },
  },
});
export const {
  gettingTreatmentOfChoice,
  gettingTreatmentOfChoiceSuccess,
  gettingTreatmentOfChoiceFailed,
  gettingTreatmentOfChoiceClear,
} = TreatmentOfChoiceSlice.actions;
export default TreatmentOfChoiceSlice.reducer;
